import { useId } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  OutlinedInput,
  Typography,
} from '@mui/material';

interface TextQuestionProps {
  question: string;
  hint?: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  required?: boolean;
  maxLength?: number;
}

const DEFAULT_MAX_LENGTH = 200;

export const TextQuestion = ({
  question,
  hint,
  value,
  onChange,
  required,
  maxLength = DEFAULT_MAX_LENGTH,
}: TextQuestionProps) => {
  const labelId = useId();
  const hintId = useId();

  return (
    <FormControl variant="standard" fullWidth sx={{ mb: 3 }}>
      <FormLabel
        id={labelId}
        sx={{
          typography: 'textMd',
          fontWeight: 600,
          color: 'text.primary',
          p: 0,
          mb: hint ? 0.5 : 1.5,
          '&.Mui-focused': { color: 'text.primary' },
        }}
      >
        {question}
        {required && (
          <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>
            *
          </Box>
        )}
      </FormLabel>
      {hint && (
        <Typography
          id={hintId}
          variant="textSm"
          sx={{ color: 'text.secondary', mb: 1.5, display: 'block' }}
        >
          {hint}
        </Typography>
      )}
      <OutlinedInput
        aria-describedby={hint ? hintId : undefined}
        value={value ?? ''}
        onChange={(event) =>
          onChange(event.target.value === '' ? undefined : event.target.value)
        }
        inputProps={{ 'aria-labelledby': labelId, maxLength }}
        sx={{ borderRadius: 1.5 }}
      />
    </FormControl>
  );
};
